module.exports = __webpack_public_path__ + "static/img/img14.fc0b914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img14.png
// module id = tbap
// module chunks = 1